"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WakeLockService = void 0;
class WakeLockService {
    static factory() {
        return new WakeLockService();
    }
    init() {
        return new Promise((resolve) => {
            navigator.wakeLock.request("screen")
                .then(function (wakeLock) {
                // console.log('The screen wake lock is granted');
                resolve(wakeLock);
            })
                .catch(function () {
                console.log('The screen wake lock is not granted');
                resolve(undefined);
            });
        });
    }
}
exports.WakeLockService = WakeLockService;
angular.module('callX').service('WakeLockService', [WakeLockService.factory]);
